export const TRANS_TYPE = {
  SFTP: 'sftp',
  FTP: 'ftp',
  VM5: 'VM5',
  TTD: 'TTD',
  META: 'Meta',
  GOOGLE_ADS: 'GoogleAds'
}
